export const tr = {
    adaptive: 'Uyarlanabilir kreatif',
    'adaptive-disclaimer':
        'Sitede istediğiniz reklam bloğuna otomatik olarak uyum sağlayan yeni uyarlanabilir reklam fikri.',
    'adaptive-info':
        "Kreatif için görseliniz şu teknik şartlara uygun olmalıdır: Maksimum çözünürlük en fazla 1500x800 piksel olmalı (daha büyük boyutlu görseller sıkıştırılacaktır), sıkıştırma işleminden sonra görselin boyutu 512 KB'ı geçmemelidir.",
    'apply-adaptive': 'Hemen dene!',
    'create-banners': 'Oluştur',
    'empty-message':
        "Burada henüz kreatifler için hiçbir fikir yok. Web sitesinin sayfa URL'sini belirtin ve sihirbaz bu sayfanın içeriğine göre kreatif fikirlerini oluşturur.",
    'progress-message': 'Sayfanın içeriği yükleniyor',
    'progress-message1': 'Sayfanın içeriği yüklenmeye devam ediyor',
    'progress-message2':
        'Sayfanın içeriği yüklenmeye devam ediyor. Çok sayıda fikir oluşturuluyor olabilir veya siteden gelen yanıtın hızı yavaştır',
    'url-placeholder': "Web sitenizin sayfa URL'si"
};
